<!-- Reschedule Appointment Modal -->
@if (isOpen) {
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    (click)="closeModal()"
    (keydown.escape)="closeModal()"
  >
    <div
      class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="text-center mb-6">
        <h2 class="text-xl font-semibold text-primary mb-4">
          {{ translationService.translate('reschedule.modal.title') }}
        </h2>
      </div>

      <!-- Current Schedule Section -->
      <div class="mb-6">
        <h3 class="text-lg font-semibold text-primary mb-2">
          {{ translationService.translate('reschedule.current.title') }}
        </h3>
        <div class="bg-gray-50 p-3 rounded-lg">
          <div class="flex justify-between text-sm">
            <span class="text-gray-600"
              >{{ translationService.translate('cancel.current.date') }} {{ formattedAppointmentDate() }}</span
            >
            <span class="text-gray-600"
              >{{ translationService.translate('cancel.current.time') }} {{ formattedAppointmentTime() }}</span
            >
          </div>
          <div class="text-sm text-gray-600 mt-1">
            {{ translationService.translate('cancel.current.patient') }} {{ getPatientName() }}
          </div>
        </div>
      </div>

      <!-- New Schedule Section -->
      <div class="mb-6">
        <h3 class="text-lg font-semibold text-primary mb-4">
          {{ translationService.translate('reschedule.new.title') }}
        </h3>
        <div class="space-y-4">
          <!-- Date and Time Row -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <!-- Date Field with DatePicker -->
            <div>
              <app-date-picker [minDate]="minDate()" (dateChange)="onDateChange($event)"></app-date-picker>
            </div>

            <!-- Time Field with TimePicker -->
            <div>
              <app-time-picker
                [startHour]="8"
                [endHour]="18"
                [intervalMinutes]="30"
                (timeChange)="onTimeChange($event)"
              ></app-time-picker>
            </div>
          </div>

          <!-- Reason Field -->
          <div>
            <input
              type="text"
              [value]="rescheduleData().reason"
              (input)="onInputChange($event, 'reason')"
              [placeholder]="translationService.translate('reschedule.reason.placeholder')"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
            />
          </div>
        </div>
      </div>

      <div class="flex gap-3 justify-center">
        <button
          type="button"
          (click)="closeModal(); $event.stopPropagation()"
          class="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
        >
          {{ translationService.translate('reschedule.button.cancel') }}
        </button>
        <button
          type="button"
          (click)="saveReschedule()"
          [disabled]="!isRescheduleFormValid()"
          [class]="
            isRescheduleFormValid()
              ? 'px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors'
              : 'px-6 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed'
          "
        >
          {{ translationService.translate('reschedule.button.save') }}
        </button>
      </div>
    </div>
  </div>
}
